"use client";
import { MessageKey, mergeIframeClick } from "@intlayer/editor";
import { useEffect } from "react";
import { useCrossFrameMessageListener } from "./useCrossFrameMessageListener.mjs";
const useIframeClickInterceptor = () => {
  const postMessage = useCrossFrameMessageListener(
    MessageKey.INTLAYER_IFRAME_CLICKED
  );
  const handlePostMessageEvent = () => {
    postMessage();
  };
  useEffect(() => {
    window.addEventListener("mousedown", handlePostMessageEvent);
    return () => window.removeEventListener("mousedown", handlePostMessageEvent);
  }, [postMessage]);
};
const useIframeClickMerger = () => useCrossFrameMessageListener(
  MessageKey.INTLAYER_IFRAME_CLICKED,
  mergeIframeClick
);
export {
  useIframeClickInterceptor,
  useIframeClickMerger
};
//# sourceMappingURL=useIframeClickInterceptor.mjs.map